import React, { memo } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { Theme, useTheme } from '@mui/material/styles';

interface Props extends SvgIconProps {
  alt?: boolean;
  dark?: boolean;
}

function Signout({ dark = false, ...props }: Props) {
  const { palette }: Theme = useTheme();

  const foreground = dark ? palette.secondary.lightest : palette.accent.main;

  return (
    <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.9 11.23a.77.77 0 00-.79.77c0 .42.35.77.79.77H16v4.78A4.5 4.5 0 0111.47 22H6.52A4.48 4.48 0 012 17.56V6.45A4.5 4.5 0 016.53 2h4.96C13.98 2 16 3.99 16 6.44v4.79H9.9zm9.73-2.69l2.92 2.91a.76.76 0 010 1.09l-2.92 2.91a.78.78 0 01-.54.23.77.77 0 01-.55-1.32l1.6-1.59H16v-1.54h4.14l-1.6-1.59a.77.77 0 010-1.09.76.76 0 011.09-.01z"
        fill={foreground}
      />
    </SvgIcon>
  );
}

export default memo(Signout);
